import PropTypes from 'prop-types'
import {
  Center,
  Heading,
  HStack,
  Text,
  useTheme,
  VStack,
} from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useMemo } from 'react'
import Card from '../../../components/Card/Card'
import CardBody from '../../../components/Card/CardBody'
import CardHeader from '../../../components/Card/CardHeader'
export const indicatorTypes = {
  currency: 'currency',
  number: 'number',
}
export default function Indicator({ title, value, icon, type }) {
  const { colors } = useTheme()
  const valueFormatted = useMemo(() => {
    if (!value) return 'Sin información'
    if (type === indicatorTypes.currency) {
      return `$${Number(value).toLocaleString('de-DE')}`
    }
    if (type === 'number') {
      return Number(value)
    }
    return value
  }, [type, value])
  return (
    <Card height="100%" width="100%" variant="indicator" borderType="primary">
      <HStack h="100%" w="100%" justifyContent="space-between">
        <VStack h="100%" w="100%" alignItems="flex-start" spacing={0}>
          <CardHeader>
            <Text variant="subtitle2">{title}</Text>
          </CardHeader>
          <CardBody>
            <Heading
              textAlign="left"
              wordBreak="break-word"
              fontSize="16px"
              variant="h6"
              color="#2D3748"
            >
              {valueFormatted}
            </Heading>
          </CardBody>
        </VStack>
        <Center
          w="45px"
          h="45px"
          bgColor={colors.gray[900]}
          boxShadow="0px 3.5px 5.5px rgba(0, 0, 0, 0.02)"
          borderRadius="12px"
        >
          <FontAwesomeIcon size="xl" icon={icon} color="white" />
        </Center>
      </HStack>
    </Card>
  )
}

Indicator.propTypes = {
  icon: PropTypes.any,
  title: PropTypes.string,
  value: PropTypes.string,
}

Indicator.propTypes = {
  icon: PropTypes.any,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
}
